<template lang="pug">
div
  Modal(ref="loseModal", :showHeader="false", v-slot:default="{ message }")
    p.text-center.mt-8.mb-4(v-html="message")

  table
    tr
      td(valign="top")
        template(v-if="isBuildMode")
          BuildDeck(ref="builder", :active.sync="active")
        template(v-else)
          SideDeck(ref="deck", :clock.sync="clock", :active.sync="active", :score="score")
      td(valign="top", style="user-select: none")
        #stage(
          :style="{ width: canvasWidth + 'px', height: canvasHeight + 'px' }",
          @click="onClick",
          @mousemove="onMouseOver",
          @mousedown="onMouseDown",
          @mouseup="onMouseUp",
          @mouseout="onMouseOut"
        )
          PipesCanvas(ref="pipesCanvas", :board.sync="board", :active="active", @pieceAdded="pieceAdded")
          PreviewCanvas(ref="previewCanvas", :board="board", :active="active", style="opacity: 0.6")
          WaterCanvas(ref="waterCanvas", :board.sync="board", @finish="onFinish")
          GridCanvas(ref="gridCanvas")
    tr
      td(colspan="2")
        h3 Required: {{ advanceScore }} | Level: {{ $state.level }} | Score: {{ score }}

        Button.btn(:disabled="!isRunning", @click="onDoneClick", :class="{ 'btn-green': isRunning }") Done

        Button.btn.ml-4(@click="onPauseClick", :class="isPaused ? 'btn-green' : 'btn-red'") {{ isPaused ? 'Continue' : 'Pause' }}
</template>

<script>
// @ is an alias to /src
let KEY = {
  UP: 38,
  DOWN: 40,
  RIGHT: 39,
  LEFT: 37,
  SPACE: 32,
  P_Key: 80
}
import LevelConfig from "@/levels"
import { sleep } from "@/utils"
import state from "@/state"

// canvas components
import PipesCanvas from "@/components/PipesCanvas.vue"
import WaterCanvas from "@/components/WaterCanvas.vue"
import GridCanvas from "@/components/GridCanvas.vue"
import PreviewCanvas from "@/components/PreviewCanvas.vue"

// deck components
import SideDeck from "@/components/SideDeck.vue"
import BuildDeck from "@/components/BuildDeck.vue"
const explosion_sound = new Audio("./explosion.mp3")
const countdown_sound = new Audio("./countdown.mp3")
const sink_sound = new Audio("./sink.mp3")
export default {
  name: "GamePage",
  components: {
    SideDeck,
    BuildDeck,
    PipesCanvas,
    GridCanvas,
    WaterCanvas,
    PreviewCanvas
  },
  data() {
    return {
      advanceScore: 200,
      board: [],
      active: null,
      firstTime: true
    }
  },
  watch: {
    clock(value) {
      if (value === 1) {
        clearInterval(this.clockTimer)
        console.log("START WATER")
        this.$state.isRunning = true
        this.$state.hasStarted = true
        this.$state.isInstant = false
        this.$refs.waterCanvas.startWater()
        explosion_sound.play()
      }
      if (value <= 0) this.clock = 0
      if (value == 5) countdown_sound.play()
    },
    async hasFinished(value) {
      if (value) await this.onFinish()
    }
  },
  mounted() {
    setTimeout(async () => {
      if (this.$state.isBuildMode) this.$refs.pipesCanvas.resetBoard()
      else if (this.$state.startGameOnLoad) await this.startNewRound()
    }, 1000)
  },
  destroyed() {
    document.removeEventListener("keyup", this.handler)
  },
  created() {
    this.handler = e => {
      console.log(e.keyCode, KEY.UP)
      switch (e.keyCode) {
        case KEY.UP:
          this.move("u")
          break
        case KEY.DOWN:
          this.move("d")
          break
        case KEY.LEFT:
          this.move("l")
          break
        case KEY.RIGHT:
          this.move("r")
          break
        case KEY.SPACE:
          if (this.isRunning) {
            this.$state.isInstant = true
          } else {
            this.clock = 1
          }
          break
        case KEY.P_Key:
          this.$state.isPaused = !this.$state.isPaused
          break
      }
      e.preventDefault()
      return false
    }
    document.addEventListener("keyup", this.handler)
  },
  methods: {
    onPauseClick() {
      this.isPaused = !this.isPaused
    },
    onDoneClick() {
      this.$state.isInstant = true
    },
    onMouseDown(e) {
      if (this.isBuildMode) this.$refs.pipesCanvas.onMouseDown(e)
    },
    onMouseUp(e) {
      if (this.isBuildMode) this.$refs.pipesCanvas.onMouseUp(e)
    },
    onMouseOut(e) {
      if (this.$state.enableHover) this.$refs.previewCanvas.onMouseOut(e)
    },
    onClick(e) {
      this.$refs.pipesCanvas.onClick(e)
    },
    onMouseOver(e) {
      if (this.$state.enableHover) this.$refs.previewCanvas.onMouseOver(e)
      if (this.isBuildMode) this.$refs.pipesCanvas.onMouseOver(e)
    },
    onResetWater() {
      this.$refs.waterCanvas.resetBoard()
      this.$refs.waterCanvas.setStartPosition()
    },
    onResetAll() {
      this.$refs.waterCanvas.resetBoard()
      this.$refs.pipesCanvas.resetBoard()
    },
    async onStartWater() {
      try {
        await this.$refs.waterCanvas.startWater()
      } catch (e) {
        console.warn(e)
      }
    },
    pieceAdded() {
      console.log("PA")
      if (!this.isBuildMode) {
        this.$refs.deck.advanceDeck()
        this.$refs.deck.drawDeck()
      }
    },

    async startNewRound() {
      console.clear()
      console.log("LEVEL ", this.$state.level, this.lc)
      let o = {
        message: `Click to start round: <br><h1>${this.level}</h1> `,
        okText: "Start Round",
        cancelText: "Exit"
      }

      if (await this.$refs.loseModal.alert(o)) {
        console.log("START ROUND")
        this.$state.hasFinished = false
        this.$state.loops = 0
        this.$state.isInstant = false

        this.$refs.pipesCanvas.resetBoard(this.lc)
        this.$refs.waterCanvas.resetBoard()
        this.clock = this.lc.time || this.$state.time
        this.advanceScore = this.score + this.lc.target
        this.countdown()
      } else {
        this.$router.push("/")
        return
      }
      //setTimeout(this.countdown, 1000)
    },
    async countdown() {
      console.log("countdown", this.clock)
      while (this.clock-- > 1) {
        console.log(this.clock, this.isPaused)
        while (this.isPaused) await sleep(500)
        await sleep(1000)
      }
    },
    async onFinish() {
      sink_sound.play()
      if (this.$state.isBuildMode) {
        return
      }
      this.$state.hasFinished = true
      if (this.$state.loops > 4) {
        // for every 4 loops add 100 points
        let bonus = this.$state.loops * 25 + Math.floor(this.$state.loops / 4) * 100
        let o = {
          message: `Created ${this.$state.loops} loops. Awarded ${bonus} points!`,
          expiration: 2000,
          okButtonVisible: false,
          cancelButtonVisible: false
        }
        await this.$refs.loseModal.alert(o)
        this.$state.score += bonus
        await sleep(500)
      }

      // remove empty tiles
      await this.$refs.pipesCanvas.remove()

      if (this.$state.score > this.advanceScore) {
        this.$state.level++
        this.startNewRound()
      } else {
        let o = {
          message: `You lost ... `,
          okText: "Start Over",
          cancelText: "Exit"
        }

        if (await this.$refs.loseModal.alert(o)) {
          this.$state.level = 1
          this.$state.score = 0
          this.startNewRound()
        } else {
          this.$router.push("/")
          return
        }
      }
      this.$state.hasFinished = false
    }
  },
  computed: {
    score() {
      return this.$state.score
    },
    level: {
      get() {
        return this.$state.level
      },
      set(value) {
        this.$state.level = value
      }
    },
    canvasWidth() {
      return this.width * state.scale * this.$tileSize
    },
    canvasHeight() {
      return this.height * state.scale * this.$tileSize
    },
    width() {
      return state.tiles.w
    },
    height() {
      return state.tiles.h
    },

    isPaused: {
      get() {
        return this.$state.isPaused
      },
      set(value) {
        this.$state.isPaused = value
      }
    },
    isRunning() {
      return this.$state.isRunning
    },
    isBuildMode() {
      return this.$state.isBuildMode
    },
    scale: {
      get() {
        return this.$state.scale
      },
      set(value) {
        this.$state.scale = value
      }
    },
    hasFinished() {
      return this.$state.hasFinished
    },
    foo() {
      return this.$state
    },

    clock: {
      get() {
        return this.$state.clock
      },
      set(value) {
        this.$state.clock = value
      }
    },
    lc() {
      return LevelConfig.find(x => x.level == this.level)
    }
  }
}
</script>

<style lang="scss">
#stage {
  position: relative;
  /*border: 2px solid black;*/
  display: inline-block;
  background-color: #cecfd8;
}

.deckWrapper {
  display: inline-block;
  border: solid 2px;
}

#stage > canvas {
  position: absolute;
}
#ui-layer {
  z-index: 3;
  border: solid 1px silver;
}
#game-layer {
  z-index: 2;
}
#background-layer {
  z-index: 1;
}

.chart td {
  border: solid 1px;
  height: 50px;
  width: 50px;
  text-align: center;
  cursor: pointer;
}

td.active {
  background-color: silver;
}

span.current {
  color: red;
}
</style>
